import { render, staticRenderFns } from "./Tema3_3-2.vue?vue&type=template&id=7b59e8ab&"
import script from "./Tema3_3-2.vue?vue&type=script&lang=js&"
export * from "./Tema3_3-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports